<template>
  <div class="right-content">
    <!--  账户设置  -->

    <div class="account-set">
      <el-form :rules="rules" ref="form" size="large" :model="form" @keyup.enter.down="keyDown">
        <el-form-item prop="photo" class="tx-upload">
          <el-upload 
            :action="upload_url" 
            :headers="headers" 
            :limit="1" 
            :on-success="handleImgSuccess"
            :on-error="handleImgError"
            :before-upload="beforeUpload"
            :show-file-list="false"
            accept="image/jpeg,image/jpg,image/png">
            <div class="tx">
              <el-image class="pic" :src="form.photo" lazy>
                <template #error>
                  <el-image class="pic" src="/static/upload/tx2.png" lazy></el-image>
                </template>
              </el-image>
              <img src="/static/iconImg/icon-photo.png" alt="" class="icon">
            </div>
          </el-upload>
          <div class="tips">
            <p>请上传正方形头像图片</p>
            <p>支持jpg、png，大小5MB以内</p>
          </div>
        </el-form-item>
        <el-form-item prop="name" class="input-item">
          <span class="tit">姓名</span>
          <el-input v-model="form.name" type="text" style="width: 366px;" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item prop="title" class="input-item">
          <span class="tit">职称</span>
          <el-input v-model="form.title" type="text" style="width: 366px;" placeholder="请输入职称"></el-input>
        </el-form-item>
        <el-form-item prop="intro" class="input-item">
          <span class="tit">简介</span>
          <el-input v-model="form.intro" type="textarea" :rows="4" style="width: 366px;" placeholder="请输入简介"></el-input>
        </el-form-item>
        <el-form-item prop="address" class="input-item">
          <span class="tit">地址</span>
          <el-input v-model="form.address" type="text" style="width: 366px;" placeholder="请输入地址"></el-input>
        </el-form-item>
        <div class="btn-save" @click="submit_info">保存修改</div>
      </el-form>
    </div>
  </div>
</template>
<script>
import attachment from "@/api/public";
import api from "@/api/index";
import { mapGetters } from 'vuex';

export default {
  name: "account_info",
  components: {},
  computed: {
    ...mapGetters('auth', ['token']),
    headers() {
      return {
        "Authorization": this.token || 'no-token'
      };
    }
  },
  data() {
    return {
      upload_url: '',
      loading: false,
      form: {
        name: '',
        photo: '',
        title: '',
        intro: '',
        address: ''
      },
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }]
      }
    }
  },
  created() {
    attachment.uploadFileUrl().then(res => {
      this.upload_url = res;
    });
    this.getUserinfo();
  },
  methods: {
    beforeUpload(file) {
      const isImage = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg';
      const isLt5M = file.size / 1024 / 1024 < 5;

      if (!isImage) {
        this.$message.error('只能上传 JPG/PNG 格式的图片！');
        return false;
      }
      if (!isLt5M) {
        this.$message.error('图片大小不能超过 5MB！');
        return false;
      }
      return true;
    },
    handleImgSuccess(res) {
      if (res.code == 4000) {
        this.$message.error({
          message: res.msg
        });
      } else {
        this.form.photo = res.data.url;
        this.$message.success({
          message: '上传文件成功！'
        });
      }
    },
    handleImgError(err) {
      this.$message.error('上传失败，请重试！');
      console.error('上传错误：', err);
    },
    //获取用户信息
    async getUserinfo() {
      this.loading = true;
      try {
        const res = await api.info({ param: 'no' });
        if (res && res.data) {
          this.form.name = res.data.name || '';
          this.form.photo = res.data.photo || '';
          this.form.title = res.data.title || '';
          this.form.intro = res.data.intro || '';
          this.form.address = res.data.address || '';
        }
      } catch (err) {
        this.$message.error(err.msg || '获取用户信息失败');
      } finally {
        this.loading = false;
      }
    },
    //enter键提交
    keyDown(e) {
      //console.log('enter');
      if (e.keyCode == 13 || e.keyCode == 100) {
        this.submit_info();
      }
    },
    submit_info() {
      this.loading = true;
      const that = this;
      this.$refs['form'].validate((valid) => {
        if (valid) {
          api.update(this.form).then(res => {
            if (res) {
              this.$message.success(res.msg || '保存成功');
              this.getUserinfo();
            }
            that.loading = false;
          }).catch(err => {
            that.loading = false;
            this.$message.error(err.msg || '保存失败');
          });
        } else {
          that.loading = false;
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.right-content {
  padding: 20px;
}

.account-set {
  max-width: 600px;

  .el-form {
    .el-form-item {
      margin-bottom: 24px;

      &.tx-upload {
        display: flex;
        align-items: center;
        margin-bottom: 30px;
        margin-left: 100px;

        :deep(.el-form-item__content) {
          display: flex;
          align-items: center;
        }

        .el-upload {
          margin-right: 20px;
        }

        .tx {
          position: relative;
          width: 100px;
          height: 100px;
          overflow: hidden;
          cursor: pointer;
          flex-shrink: 0;

          .pic {
            width: 100%;
            height: 100%;
            border-radius: 50%;
            object-fit: cover;
          }

          .icon {
            position: absolute;
            bottom: 0;
            right: 0;
            width: 32px;
            height: 32px;
            background: #ccc;
            border-radius: 50%;
            padding: 7px;
            border: 3px solid #fff;
            z-index: 10;
            object-fit: contain;
          }
        }

        .tips {
          display: flex;
          flex-direction: column;
          justify-content: center;
          margin-left: 20px;

          p {
            margin: 0;
            font-size: 13px;
            color: #999;
            line-height: 1.8;
          }
        }
      }

      &.input-item {
        display: flex;
        align-items: center;

        .tit {
          width: 120px;
          font-size: 14px;
          color: #333;
          text-align: right;
          margin-right: 18px;
          flex-shrink: 0;
        }

        .el-input,
        .el-select,
        .el-cascader,
        .el-date-picker {
          width: 366px;
        }
      }
    }
  }

  .btn-save {
    margin-left: 138px;
    margin-top: 30px;
    width: 200px;
    height: 44px;
    line-height: 44px;
    text-align: center;
    background: #1e9dd4;
    color: #fff;
    font-size: 15px;
    border-radius: 4px;
    cursor: pointer;
    transition: background 0.3s;

    &:hover {
      background: #1789bd;
    }
  }
}

.account-set .el-input {
  height: 56px;
  width: 366px !important;
}

.account-set .el-select {
  height: 56px;
  width: 366px !important;
}

.account-set .el-input__wrapper {
  height: 56px;
  border-radius: 8px;
  border: 1px solid #ccc;
  box-shadow: none;
}

:deep(.el-select .el-input) {
  height: 56px;
}

:deep(.el-cascader .el-input) {
  height: 56px;
}

:deep(.el-date-editor.el-input) {
  height: 56px;
}

:deep(.el-date-editor .el-input__wrapper) {
  height: 56px;
}

:deep(.account-set .el-form-item__error) {
  margin-left: 138px;
}

:deep(.el-radio-group) {
  display: flex;
  gap: 20px;
}

:deep(.el-radio) {
  margin-right: 0;
}
</style>